var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 1V5.53333C6.33333 6.28007 6.33333 6.65344 6.47866 6.93865C6.60649 7.18954 6.81046 7.39351 7.06135 7.52134C7.34656 7.66667 7.71993 7.66667 8.46667 7.66667H17.5333C18.2801 7.66667 18.6534 7.66667 18.9387 7.52134C19.1895 7.39351 19.3935 7.18954 19.5213 6.93865C19.6667 6.65344 19.6667 6.28007 19.6667 5.53333V2.33333M19.6667 25V16.4667C19.6667 15.7199 19.6667 15.3466 19.5213 15.0613C19.3935 14.8105 19.1895 14.6065 18.9387 14.4787C18.6534 14.3333 18.2801 14.3333 17.5333 14.3333H8.46667C7.71993 14.3333 7.34656 14.3333 7.06135 14.4787C6.81046 14.6065 6.60649 14.8105 6.47866 15.0613C6.33333 15.3466 6.33333 15.7199 6.33333 16.4667V25M25 9.43398V18.6C25 20.8402 25 21.9603 24.564 22.816C24.1805 23.5686 23.5686 24.1805 22.816 24.564C21.9603 25 20.8402 25 18.6 25H7.4C5.15979 25 4.03969 25 3.18404 24.564C2.43139 24.1805 1.81947 23.5686 1.43597 22.816C1 21.9603 1 20.8402 1 18.6V7.4C1 5.15979 1 4.03969 1.43597 3.18404C1.81947 2.43139 2.43139 1.81947 3.18404 1.43597C4.03969 1 5.15979 1 7.4 1H16.566C17.2183 1 17.5444 1 17.8513 1.07368C18.1234 1.139 18.3835 1.24675 18.6221 1.39296C18.8912 1.55787 19.1218 1.78847 19.583 2.24968L23.7503 6.41699C24.2115 6.87819 24.4421 7.1088 24.607 7.37791C24.7533 7.6165 24.861 7.87662 24.9263 8.14872C25 8.45562 25 8.78174 25 9.43398Z",
    stroke: "#444CE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveProgress);
export default __webpack_public_path__ + "static/media/save_progress.ed14490c02ee6abb5d91475195724913.svg";
export { ForwardRef as ReactComponent };